var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-contact wrap"},[_c('h2',{attrs:{"id":"mailto"}},[_vm._v("Contact")]),_c('p',{staticClass:"sub-title"},[_vm._v("お仕事のご依頼・お問い合わせ")]),_c('h3',{staticClass:"mail-contact"},[_vm._v("メールでのお問い合わせ")]),_c('HomeContactContactForm',{staticClass:"contact-form"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }